import { createSlice } from '@reduxjs/toolkit';

const commonState = createSlice({
  name: 'common',
  initialState: {
    isSidebarDrawerOpen: false,
    loading: false,
    selectedTitle: '',
    isST: false,
    project: localStorage.getItem('client') || '',
  },

  reducers: {
    updateValue: (state, action) => {
      state.isSidebarDrawerOpen = action.payload;
    },
    setSelectedTitle: (state, action) => {
      state.selectedTitle = action.payload;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setIsST: (state, action) => {
      state.isST = action.payload;
    },
    setProject: (state, action) => {
      state.project = action.payload;
      if (action.payload) {
        localStorage.setItem('client', action.payload);
      } else {
        localStorage.removeItem('client');
      }
    },
  },
});

export default commonState;
export const { updateValue, setSelectedTitle, startLoading, stopLoading, setIsST, setProject } =
  commonState.actions;
